<template>
    <div>
        <navigation-bar Close Bell/>
        <div class="main">
            <item-grid class="two-gird">
                <!--TODO:領取票券清單-->
                <ticket-item :list="ticketList" :dataToken="dataToken">
                    <img src="@/assets/images/tag3.svg" alt="">
                </ticket-item>
            </item-grid>
        </div>
    </div>

</template>

<script>
    import ItemGrid from '@/components/category/ItemGrid.vue'
    import TicketItem from '@/views/home/components/TicketItem.vue'
    import * as constDefine from "@/store/constDefine";
export default {
    name: 'TicketList',
    components: {
        ItemGrid,
        TicketItem,
    },
    data() {
        return {
            parameterString: this.$route.query.p ? this.$route.query.p : '',
            storeId: 0,
            objectType: 0,
            objectId: 0,
            dataToken: "",
            ticketList: [],
        }
    },
    created() {
        if (this.parameterString !== "") {
            let parameterObj = this.$crypto.decryptObjectText(this.parameterString)
            this.storeId = Number(parameterObj.storeId) || 0;
            this.objectType = Number(parameterObj.objectType) || 0;
            this.objectId = Number(parameterObj.objectId) || 0;

            this.dataToken = this.$crypto.objectToURIComponent({
                "objectType": this.objectType,
                "objectId": this.objectId,
            })
        }

        if (this.storeId > 0) {
            this.setupData();
        } else if (this.objectType === constDefine.MerchantType.ShoppingAreaActivity && this.objectId > 0) {
            this.setupShoppingAreaActivityData();
        } else if (this.objectType === constDefine.MerchantType.ShoppingArea && this.objectId > 0) {
            this.setupShoppingAreaData();
        }
    },
    methods: {
        setupData: function () {
            //票券清單
            this.$http.fetch`GetSeizeTicketList${{
                storeId: this.storeId,
            }} ${json => {
                if (json.status) {
                    this.ticketList = json.data;
                }
            }}`;
        },
        setupShoppingAreaActivityData: function () {
            this.$http.fetchWithEncrypt`GetShoppingAreaActivityOffersList${{
                objectType: this.objectType,
                objectId: this.objectId,
            }} ${json => {
                if (json.status) {
                    this.ticketList = json.data.dataList;
                }
            }}`;
        },
        setupShoppingAreaData() {
            this.$http.fetchWithEncrypt`GetShoppingAreaOffersList${{
                objectType: this.objectType,
                objectId: this.objectId,
            }} ${json => {
                if (json.status) {
                    this.ticketList = json.data.dataList;
                }
            }}`;
        }
    }
}
</script>
<style lang="less" scoped>
    /deep/.shop-item{
        @media(min-width: 1024px){
            margin: 5px -20px 0;
        }
    }
</style>